import german from "@/assets/locales/patient/de.json"
import english from "@/assets/locales/patient/en.json"
import french from "@/assets/locales/patient/fr.json"
import italian from "@/assets/locales/patient/it.json"
import { Language } from "@/types/__generated__/union-types"

type Resources = {
  [key in Language]: { translation: typeof english }
}

const RESOURCES: Resources = {
  ENGLISH: {
    translation: english,
  },
  GERMAN: {
    translation: german,
  },
  ITALIAN: {
    translation: italian,
  },
  FRENCH: {
    translation: french,
  },
}

export const getPatientTranslation = (lng: Language) => {
  return RESOURCES[lng].translation
}
